import { useEffect } from 'react';
import { isUserAuthenticated, sleep } from '@lib/utils';

export const useTriggerPopUpPaywall = ({
  user,
  isAuthorisedToViewRestrictedPageContent,
  setShowModal
}) => {
  useEffect(() => {
    openModal();
  }, [isAuthorisedToViewRestrictedPageContent]);

  const openModal = async () => {
    if (
      !isUserAuthenticated(user) ||
      !isAuthorisedToViewRestrictedPageContent
    ) {
      await sleep(5000);
      setShowModal(true);
    }
  };
};
